import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';

@Injectable()
export class AcmAdminError extends ErrorHandler {
  private router: Router;

  // avoid circular dependency
  constructor(private injector: Injector) {
    super();
  }

  public handleError(error: any): void {
    this.router = this.injector.get(Router);
    if (error.rejection) {
      this.handlePromiseRejections(error.rejection);
    }
    throw error;
  }

  private handlePromiseRejections(rejectionData): void {
    switch (rejectionData.errorCode) {
      case 'access_denied':
        this.router.navigate(['/error'], {
          state: {
            error: {
              name: 'Access denied',
              message: rejectionData.message,
              statusCode: '403'
            }
          }
        });
        break;
    }
  }
}

